import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginService } from './login.service';

import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'candidate-data-entry';
  loggedIn: boolean = false
  isLoggedIn$: Observable<boolean>;

  constructor(
    private loginService: LoginService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {

  }

  showHomeButton() {
    return true
  }

  showUserMenu() {
    return true
  }

  ngOnInit() {
    this.isLoggedIn$ = this.loginService.isLoggedIn; // {2}
    this.isLoggedIn$.subscribe(logIn => {
      this.loggedIn = logIn; 
    })
  }

  signoutClicked() {
    this.loginService.logout()
    this.router.navigate(['login']);
  }

  // showMessage(msg) {
  //   this.snackBar.open(msg, "Info", { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' });
  // }
  // showError(msg) {
  //   this.snackBar.open(msg, "Error", { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' });
  // }

 

}
